const initialState = {
  data: null,
  answerText: '',
  attachments: [],
  internalOnly: false,
  isVizKnowledgeBase: false,
  expirationDate: '',
  isButtonEnable: true,
  submissionType: '',
  ownRecords: true,
  answerUuid: '',
  questionText: '',
  anotherExpertAnswer: {},
  declinedData: [],
  declineIsLoading: false,
  seekerAttachments: [],
  ratingBool: true,
  answeredBoolean: true,
  pageNumber: 0,
  newDeclinedLoader: true,
  compareAttachments: [],
  changeAnswerBool: false,
  publishButtonBool:false

}

const editorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'questionDataForEditor':
      state = { ...state, data: payload };
      state = { ...state, declinedData: [] };
      state = { ...state, anotherExpertAnswer: {} };
      state = { ...state, questionText: payload.questionText };
      state = { ...state, declineIsLoading: true };
      if (payload.usageAccess !== undefined && payload.usageAccess !== 'public') {
        state = { ...state, internalOnly: true };
      }
      return state;
    case 'updateNewDeclinedLoader':
      state = { ...state, newDeclinedLoader: payload };
    case 'updateExpirationDateForEditor':
      state = { ...state, expirationDate: payload };
      return state;
    case 'updateCheckBoxValForEditor':
      if (payload.key === 'internal') {
        state = { ...state, internalOnly: payload.flag };
      } else {
        state = { ...state, isVizKnowledgeBase: payload.flag };
      }
      return state;
    case 'updateAnswerTextForEditor':
      state = { ...state, answerText: payload };
      return state;
    case 'updateButtonEnableForEditor':
      state = { ...state, isButtonEnable: payload };
      return state;
    case 'updateSubmissionTypeForEditor':
      state = { ...state, submissionType: payload };
      return state;
    case 'updateOwnRecordsForEditor':
      state = { ...state, ownRecords: payload };
      return state;
    case 'resetStateForEditor':
      let storeState = {
        data: null,
        answerText: '',
        attachments: [],
        internalOnly: false,
        isVizKnowledgeBase: false,
        expirationDate: '',
        isButtonEnable: true,
        submissionType: '',
        ownRecords: true,
        answerUuid: '',
        anotherExpertAnswer: {},
        declinedExpertData: [],
        declinedDocData: []
      }
      state = storeState;
      return state;
    case 'updateAttachmentsForEditor':
      state = { ...state, attachments: payload };
      return state;
    case 'updateQuestiontextForEditor':
      state = { ...state, questionText: payload };
      return state;
    case 'updateAnotherExpertAnsweredForEditor':
      state = { ...state, anotherExpertAnswer: payload };
      return state;
    case 'AnsweredPageBool':
      state = { ...state, answeredBoolean: payload };
      return state;
    case 'updateDeclinedAnsweredForEditor':
      state = { ...state, declinedData: payload };
      state = { ...state, declineIsLoading: false };
      return state;
    case 'seekerAttachmentData':
      state = { ...state, seekerAttachments: payload }
      return state;
    case "checkEditedAnswer":
      state = { ...state, changeAnswerBool: payload }
      return state;

    case 'updateRatingBoolean':
      state = { ...state, ratingBool: payload }
      return state;
    case "savePageNumberAnswer":
      state = { ...state, pageNumber: payload }
      return state;
    case "getAttachments":
      state = { ...state, compareAttachments: payload }
      return state;
      case "ChangePublishButton":
        state = { ...state, publishButtonBool: payload }
        return state;
    case "CLEAR_COMPARE_ATTACHMENTS":
      return {
        ...state,
        compareAttachments: []
      };
    default:
      return state
  }
}

export default editorReducer;

// getAttachments ChangePublishButton